{
  "voucherType.oneTimeUse": "一次性优惠券",
  "voucherType.multiUse": "多次使用优惠券",
  "voucher.badge.vouchersForRewards": "奖励",
  "voucher.badge.vouchersForFree": "免费",
  "voucher.badge.vouchersForPoints": "积分",
  "voucher.badge.vouchersAsCashback": "现金返还",
  "voucherOverviewPage.tabs.vouchersForRewards": "优惠券作为奖励",
  "voucherOverviewPage.tabs.vouchersForFree": "免费优惠券",
  "voucherOverviewPage.tabs.vouchersForPoints": "积分优惠券",
  "voucherOverviewPage.tabs.vouchersAsCashback": "优惠券现金返还",
  "voucherOverviewPage.card.activeAndConnectedTooltip.rewards": "池已激活并与以下操作/福利相关联：<br/>。",
  "voucherOverviewPage.card.activeAndConnectedTooltip.tiers": "池已激活，优惠在 Loyalty Wallet/API 中显示到以下层级：<br/>",
  "voucherOverviewPage.card.readyToConnectTooltip.rewards": "池已准备好连接到操作和福利。",
  "voucherOverviewPage.card.readyToConnectTooltip.tiers": "池已准备好使用，但优惠尚未激活。要激活优惠，请选择您希望优惠券包含的层级。",
  "voucherOverviewPage.card.inactiveTooltip": "要激活此奖励，完成定义优惠券设置。",
  "voucherOverviewPage.card.expiredTooltip": "池或优惠券有效期已过期。更新代码和有效期以自动重新激活池。",
  "voucherOverviewPage.card.emptyTooltip": "池没有任何代码。上载新代码以自动重新激活池。",
  "voucherOverviewPage.card.connectedTo": "连接至",
  "voucherOverviewPage.createNew.vouchersAsCashback": "创建优惠券池",
  "voucherOverviewPage.createNew": "创建优惠券池",
  "voucherOverviewPage.notification.vouchersForRewards.learnMoreLinkText": "了解更多",
  "voucherOverviewPage.notification.vouchersForRewards": "要支持您的奖励优惠，请先创建优惠券池。然后，您可以将优惠券池连接到操作和福利。{learnMoreLink}。",
  "voucherOverviewPage.notification.vouchersForPoints.learnMoreLinkText": "了解更多",
  "voucherOverviewPage.notification.vouchersForPoints": "要支持兑换优惠，请先创建优惠券池。然后，您可以将优惠券池连接到忠诚度钱包以支持您的兑换优惠。{learnMoreLink}。",
  "voucherOverviewPage.notification.vouchersForFree.learnMoreLinkText": "了解更多",
  "voucherOverviewPage.notification.vouchersForFree": "在连接到 Loyalty Wallet 的优惠券池中免费管理优惠券以支持您的免费优惠。{learnMoreLink}。",
  "voucherOverviewPage.notification.vouchersAsCashback.learnMoreLinkText": "了解更多",
  "voucherOverviewPage.notification.vouchersAsCashback": "现金返还优惠券会自动发送给符合定义消费要求的会员。累计消费根据您上载的会员购买数据计算。{learnMoreLink}。",
  "voucherOverviewPage.title": "优惠券",
  "voucherOverviewPage.card.deleteDialog.headline": "是否确定要删除此池？",
  "voucherOverviewPage.card.deleteDialog.content": "删除此池后，设置和上载的代码将永久删除。",
  "voucherOverviewPage.card.subTitle.poolExpration": "池过期：",
  "voucherOverviewPage.card.subTitle.voucherValidity": "优惠券有效期：",
  "voucherOverviewPage.card.subTitle.voucherValidity.unlimited": "无限制",
  "voucherOverviewPage.card.subTitle.voucherSingle": "优惠券",
  "voucherOverviewPage.filters.search.label": "搜索",
  "voucherOverviewPage.filters.status.label": "状态",
  "voucherOverviewPage.filters.voucherType.label": "优惠券类型",
  "voucher.validity.defaultMessage": "验证优惠券代码时出错。请稍后重试。",
  "voucher.duplicate.voucher.namePrefix": "副本 ",
  "rewardSetupRedemption.notification.vouchersForFree": "优惠根据您定义的层级和日期显示给会员。如果没有有效的优惠券和活动的优惠券池，优惠将无法生效。",
  "rewardSetupRedemption.notification.vouchersForPoints": "定义此优惠券池的积分值和会员的兑换优惠。选择层级且优惠券池处于活动状态后，优惠将立即显示在 Loyalty Wallet 中的会员面前。",
  "rewardSetupRedemption.notification.vouchersAsCashback": "定义现金返还优惠券值。只有选定市场和层级的会员才能根据其累计消费赚取现金返还优惠券。",
  "rewardSetup.title.new": "新优惠券池",
  "rewardSetup.multiLangPopupTitle": "基于语言的 URL",
  "rewardSetup.confirmSubmitMessage": "选择添加到池以将新代码保存在池中并完成上载。",
  "rewardSetupPoolSettings.notification.cashback": "此优惠券池根据您定义的规则和限制支持您的现金返还计划。您只能为现金返还计划定义一个优惠券池。",
  "rewardSetupPoolSettings.title": "常规设置",
  "rewardSetupPoolSettings.reward.name.label": "池名称",
  "rewardSetupPoolSettings.reward.name.tooltip": "将此池连接到福利和操作时使用的池的内部名称。",
  "rewardSetupPoolSettings.voucherType.label": "优惠券类型",
  "rewardSetupPoolSettings.isRemoveOnUse.label": "优惠券在会员使用后自动删除",
  "rewardSetupPoolSettings.isRemoveOnUse.tooltip": "仅当您在销售数据中包含字段 s_coupon 时，优惠券自动删除功能才会起作用。",
  "rewardSetupPoolSettings.voucherName.label": "优惠券名称",
  "rewardSetupPoolSettings.voucherName.tooltip": "输入向会员显示的优惠券名称。",
  "rewardSetupPoolSettings.voucherIcon.label": "优惠券图标",
  "rewardSetupPoolSettings.voucherIcon.selectIconText": "添加到优惠券",
  "rewardSetupPoolSettings.voucherIcon.tooltip": "选择向会员显示的图标。",
  "rewardSetupPoolSettings.blockExternalLink.url.label": "外部 URL",
  "rewardSetupPoolSettings.blockExternalLink.url.tooltip": "您可以添加 URL，该 URL 可直接从 Loyalty Wallet 中的优惠券链接到某个页面。",
  "rewardSetupPoolSettings.blockExternalLink.text.label": "URL 文本",
  "rewardSetupPoolSettings.blockExternalLink.text.tooltip": "输入要在此 URL 上显示的文本，该文本会显示给 Loyalty Wallet 中的会员。",
  "rewardSetupPoolSettings.voucherValue.label": "优惠券值",
  "rewardSetupPoolSettings.voucherValue.tooltip": "如果您为此优惠券分配了值，则该值将用于计算投资回报率并跟踪会员在其 Loyalty Wallet 中的货币价值。",
  "rewardSetupRedemptionValue.valueInPointsHeaderToolTip.free": "选择您想要提供此免费优惠券的层级。",
  "rewardSetupRedemptionValue.valueInPointsHeaderToolTip.cashback": "选择您想要提供现金返还优惠券的层级。定义每个层级获得现金返还优惠券所需的消费阈值。",
  "rewardSetupRedemptionValue.valueInPointsHeaderToolTip.points": "选择您想要提供积分优惠券的层级。定义每个层级获得积分优惠券所需的积分数。",
  "rewardSetupRedemptionValue.redemptionMessageTooltip.free": "输入要在 Loyalty Wallet 中显示的优惠券优惠消息。",
  "rewardSetupRedemptionValue.redemptionMessageTooltip.points": "输入要在 Loyalty Wallet 中显示的优惠券优惠消息。文本字段包含每个层级定义的积分值令牌。",
  "rewardSetupRedemptionValue.points": "积分",
  "rewardSetupRedemptionValue.notification.cashback": "启用现金返还计划后，该计划将在定义的市场和层级中可用。现金返还优惠显示在 Loyalty Wallet 中，会员可以根据其累计消费赚取现金返还优惠券。<br>。会员只能在计划处于活动状态时累积现金返还。禁用该计划后，现金返还将从钱包中移除，会员将停止赚取现金返还。会员已累积的任何现金返还金额都将保存，以防计划再次启用。",
  "rewardSetupRedemptionValue.offerTitle.cashback": "现金返还优惠",
  "rewardSetupRedemptionValue.offerTitle.other": "兑换优惠",
  "rewardSetupRedemptionValue.targetMarkets.cashback.label": "现金返还定位",
  "rewardSetupRedemptionValue.targetMarkets.other.label": "优惠定位",
  "rewardSetupRedemptionValue.targetMarkets.cashback.tooltip": "选择您想要提供此优惠的市场。",
  "rewardSetupRedemptionValue.targetMarkets.other.tooltip": "选择此优惠的目标市场。此优惠仅在目标市场 Loyalty Wallet 中有效并显示。",
  "rewardSetupRedemptionValue.offerMessage.title": "优惠消息 ",
  "rewardSetupRedemptionValue.offerMessage.tooltip": "显示消息格式",
  "rewardSetupRedemptionValue.blockExternalLink.url.label": "外部 URL",
  "rewardSetupRedemptionValue.blockExternalLink.url.tooltip": "您可以添加 URL，该 URL 可直接从 Loyalty Wallet 中的优惠券链接到某个页面。",
  "rewardSetupRedemptionValue.blockExternalLink.text.tooltip": "输入要在此 URL 上显示的文本，该文本会显示给 Loyalty Wallet 中的会员。",
  "rewardSetupRedemptionValue.blockExternalLink.text.label": "URL 文本",
  "rewardSetupUpload.previewPoolSampleCodes.title": "预览优惠券代码",
  "rewardSetupUpload.popupUploadError.title": "上载文件时出错。",
  "rewardSetupUpload.popupResetPool.title": "是否确定要删除池代码？",
  "rewardSetupUpload.popupResetPool.notice": "删除池后，将删除现有代码。",
  "rewardSetupUpload.refillReminder.label": "补充提醒",
  "rewardSetupUpload.refillReminder.tooltip": "输入池中剩余的有效代码数量，以触发补充提醒。",
  "rewardSetupUpload.popupUploadError.content": "上载文件时出错。\n由于以下错误，无法上载：",
  "rewardSetupUpload.sampleCodes.content": "这是此池中一些优惠券代码的列表。使用这些代码检查您是否上载了正确的池。",
  "rewardSetupUpload.poolStatus.codeStatusLabel": "代码状态",
  "rewardSetupUpload.poolStatus.preview.tooltip": "预览代码",
  "rewardSetupUpload.poolStatus.delete.tooltip": "删除代码",
  "rewardSetupUpload.poolStatus.table.header.currentlyAvailable": "可用代码",
  "rewardSetupUpload.poolStatus.table.header.numUploads": "上载次数",
  "rewardSetupUpload.poolStatus.table.header.totalCodes": "上载代码总计",
  "rewardSetupUpload.poolStatus.table.header.firstUplaod": "首次上载",
  "rewardSetupUpload.poolStatus.table.header.lastUplaod": "最后上载",
  "rewardSetupUpload.poolStatus.table.header.poolStatus": "池状态",
  "rewardSetupUpload.pendingUpload.table.header.fileName": "文件名称",
  "rewardSetupUpload.pendingUpload.table.header.fileSize": "文件大小",
  "rewardSetupUpload.pendingUpload.table.header.numCodes": "代码数",
  "rewardSetupUpload.newUplad.learnMore": "了解更多",
  "rewardSetupUpload.newUplad.contentLink": "了解更多",
  "rewardSetupUpload.newUplad.notification.content": "如果您要将新代码上载到现有池，请确保将有效期设置为与现有代码匹配。{contentLink}",
  "rewardSetupUpload.newUplad.label": "上载代码",
  "rewardSetupUpload.newUplad.placeholder": "选择要上载的 CSV 文件。",
  "rewardSetupUpload.newUplad.tooltip": "代码列表必须是 CSV 文件中的内容。最大文件大小为 15 MB。",
  "rewardSetupUpload.newUplad.sampleCsv": "示例 CSV 模板",
  "rewardSetupUpload.newUplad.sampleLink": "示例 CSV 模板",
  "rewardSetupUpload.newUplad.downloadSample": "下载 {sampleLink} 以用作上载列表的模板。",
  "rewardSetupUpload.deleteDialog.headline": "是否确定删除此文件？",
  "rewardSetupUpload.deleteDialog.content": "删除此文件后，代码将不会添加到池中。",
  "rewardSetupUpload.error.upload": "尝试上载文件时出现错误。",
  "rewardSetupUpload.error.fileSize": " 文件大小大于 15MB。请上载较小的文件。",
  "rewardSetupUpload.error.fileEmpty": "上载的文件为空。请尝试上载包含数据的文件。",
  "rewareSetupValidity.title": "池和优惠券",
  "rewareSetupValidity.poolValidity.label": "池有效期",
  "rewareSetupValidity.poolValidity.tooltip": "选择此池中上载代码的有效期。个人会员的有效期以会员获得优惠券的日期为准。{urlLink}",
  "rewareSetupValidity.voucherValidityType.label": "优惠券有效期选项：",
  "rewareSetupValidity.voucherValidityType.tooltip": "选择此池中优惠券的有效期类型。优惠券过期后，将从 Loyalty Wallet 移除访问权限。",
  "rewareSetupValidity.voucherValidity.label": "选择有效期",
  "rewareSetupValidity.voucherValidity.tooltip": "从会员获得优惠券之日起选择优惠券的有效期。优惠券过期后，将从 Loyalty Wallet 移除访问权限。",
  "rewareSetupValidity.voucherExpiryDate.label": "选择优惠券过期",
  "rewareSetupValidity.limitValue.label": "优惠数量",
  "rewareSetupValidity.limitValue.tooltip": "输入每个会员可从此池中兑换优惠券的次数。会员达到次数后，他们将不再看到该优惠券。",
  "rewareSetupValidity.offerRestrictions.title": "优惠限制",
  "rewareSetupValidity.offerRestrictions.tooltip.rewardActive": "输入每个会员在此优惠的规定时间期间内可兑换优惠券的次数。激活新优惠后，限制也会重置并重新激活。",
  "rewareSetupValidity.offerRestrictions.tooltip.rewardNotActive": "选择每个会员在此优惠的定义时间期间内可以兑换优惠券的次数。",
  "rewareSetupValidity.redemption.limitType.label": "优惠限制",
  "rewareSetupValidity.redemption.limitType.tooltip": "限制在状态和有效期设置中定义的时间期间内有效。激活新优惠后，限制也会重置并重新激活。",
  "rewareSetupValidity.offerStatusAndValidity.title": "优惠状态和有效期",
  "rewareSetupValidity.offerStatusAndValidity.tooltip": "选择优惠状态和此优惠在 Loyalty Wallet 中向会员提供的时间期间。",
  "rewareSetupValidity.rewardModifyOrNew.tooltip": "选择优惠状态和此优惠在 Loyalty Wallet 中向会员提供的时间期间。",
  "rewareSetupValidity.rewardModifyOrNew.label": "优惠状态和有效期",
  "rewareSetupValidity.poolDateValidity.valid.alertText": "优惠券过期",
  "rewareSetupValidity.poolDateValidity.invalid.alertText": "无效池有效期",
  "rewareSetupValidity.poolDateValidity.valid.alertMessage": "池有效期已设置。此池中的最后几张优惠券可在 {datetext} 获得（池有效期 - 优惠券有效期 - 奖励分配延迟）。我们会在池过期前 14 天向您发送提醒，要求您上载新代码。请务必上载新代码并更新池有效期，否则池将自动断开连接，会员将无法获得或兑换优惠券。",
  "rewareSetupValidity.poolDateValidity.invalid.alertMessage": "输入池有效期之前的优惠券有效期，其中还包括奖励分配延迟时间。{urlLink}",
  "validity.voucherValidity.duration.presence": "输入大于零的优惠券有效期。",
  "validity.voucherValidity.duration.numericality.notInteger": "输入大于零的优惠券有效期。",
  "validity.voucherValidity.duration.numericality.notGreaterThan": "输入大于零的优惠券有效期。",
  "validity.voucherValidity.voucherExpiryDate": "输入早于池有效期的优惠券过期日期。",
  "validity.voucherValidity.voucherExpiryDate.FIXED_DATE": "输入早于优惠券过期日期的优惠结束日期。",
  "validity.voucherValidity.voucherExpiryDate.LIMITED_FROM_EARN": "输入早于优惠券过期日期的优惠结束日期。",
  "validity.voucherValidity.voucherExpiryDate.other": "输入早于池有效期的优惠结束日期。",
  "rewardValidator.poolSettingsStepConstraints.voucherName.presence": "输入优惠券名称。",
  "rewardValidator.poolSettingsStepConstraints.name.presence": "输入池名称。",
  "rewardValidator.poolSettingsStepConstraints.name.exclusionIgnoreCase": "此名称已存在。输入唯一名称。",
  "rewardValidator.redemption.targetMarkets.presence": "输入兑换目标市场。",
  "rewardValidator.rvalidity.poolValidity.presence": "输入池有效期。",
  "rewardValidator.validity.voucherValidity.duration.messageRequired": "输入大于零的优惠券有效期。",
  "rewardValidator.validity.voucherValidity.duration.messageHigherThanZero": "输入大于零的优惠券有效期。",
  "rewardValidator.validity.voucherExpiryDate.presence": "输入优惠券过期日期。",
  "rewardValidator.validity.voucherExpiryDate.voucherExpiryDate": " 输入早于池有效期的优惠券过期日期。",
  "rewardValidator.validity.refillReminder.presence": "输入大于或等于零的补充提醒。",
  "rewardValidator.validity.refillReminder.numericality.notInteger": "输入大于或等于零的补充提醒。",
  "rewardValidator.validity.refillReminder.numericality.notGreaterThan": "输入大于或等于零的补充提醒。",
  "voucherOverviewPage.card.scheduledTooltip": "池可以使用，优惠计划如下：{text}。",
  "voucherDashboard.overviewLinkText.vouchersForRewards": "转到优惠券作为奖励",
  "voucherDashboard.overviewLinkText.vouchersForPoints": "转到积分优惠券",
  "voucherDashboard.overviewLinkText.vouchersForFree": "转到免费优惠券",
  "voucherDashboard.overviewLinkText.vouchersAsCashback": "转到优惠券作为现金返还",
  "voucherDashboard.downloadVoucherDataButton.label": "下载优惠券数据",
  "voucherDashboard.downloadVoucherDataButton.tooltipAsReward": "数据自九月九日起可用。",
  "voucherDashboard.editButton.label": "编辑优惠券",
  "voucherDashboard.voucherCreatedAt": "优惠券池创建于 {time}",
  "voucherDashboard.vouchesAttachedWidget.title": "已附加优惠券",
  "voucherDashboard.vouchesAttachedWidget.kpiTitle": "已附加优惠券总数",
  "voucherDashboard.vouchesAttachedWidget.kpiTooltip": "已分配给合格会员的优惠券数量。",
  "voucherDashboard.vouchesAttachedWidget.chartTotalMetric": "总计",
  "voucherDashboard.vouchesDistributedWidget.title": "公开的优惠券代码",
  "voucherDashboard.vouchesDistributedWidget.kpiTitle": "公开的优惠券总计",
  "voucherDashboard.vouchesDistributedWidget.kpiTooltip": "向忠诚度会员公开的优惠券代码数量。",
  "voucherDashboard.vouchesDistributedWidget.chartTotalMetric": "总计",
  "voucherOverviewPage.card.subTitle.availableCoupons": "可用 {text}",
  "voucher.redemption.message.text.vouchersAsCashback": "每消费 {text}，即可获得一张现金返还优惠券。"
}
